export default __webpack_public_path__ + "static/media/Prochile.cfd1ab8d.svg";